<template>
<div class="px-3">
	<h6 class="fw-bold mb-2">Схема діаграми</h6>
	<svg
		viewBox="0 0 800 480"
		xmlns="http://www.w3.org/2000/svg"
		class="border mb-3"
		style="max-width: 100%; height: auto;"
	>
		<!-- Top pannel -->
		<rect x="10" y="10" width="780" height="30" fill="none" stroke="#6c757d" stroke-width="1"/>
		<text x="400" y="30" text-anchor="middle" font-size="14" fill="#212529">
			Панель вибору періоду та метрик
		</text>
		
		<!-- Lines -->
		<rect x="10" y="55" width="780" height="200" fill="#ffffff" stroke="#6c757d" stroke-width="1"/>
		<text x="400" y="75" text-anchor="middle" font-size="14" fill="#495057">
			Графік ліній метрик
		</text>
		<polyline points="50,180 100,150 150,160 200,140 250,155 300,145 350,150 400,160 450,155 500,140 550,150 600,165 650,155 700,160 750,150" fill="none" stroke="#dc3545" stroke-width="2"/>
		<polyline points="50,210 100,200 150,195 200,205 250,190 300,185 350,180 400,175 450,180 500,175 550,180 600,185 650,180 700,175 750,180" fill="none" stroke="#0d6efd" stroke-width="2"/>
		<polyline points="50,230 100,225 150,235 200,220 250,230 300,225 350,220 400,215 450,220 500,225 550,220 600,215 650,220 700,225 750,220" fill="none" stroke="#6f42c1" stroke-width="2"/>
		
		<!-- Charts -->
		<rect x="10" y="270" width="780" height="150" fill="#ffffff" stroke="#6c757d" stroke-width="1"/>
		<text x="400" y="285" text-anchor="middle" font-size="14" fill="#495057">
			Діаграма метрик якості зв'язку
		</text>
		<rect x="50" y="295" width="700" height="20" fill="#d4edda" opacity="0.7"/>
		<rect x="50" y="320" width="700" height="20" fill="#d4edda" opacity="0.7"/>
		<rect x="50" y="345" width="700" height="20" fill="#d4edda" opacity="0.7"/>
		<rect x="50" y="370" width="700" height="20" fill="#d4edda" opacity="0.7"/>
		<rect x="50" y="395" width="700" height="20" fill="#d4edda" opacity="0.7"/>
		
		<!-- Data zoom -->
		<rect x="10" y="435" width="780" height="30" fill="#cfe2ff" stroke="#0d6efd" stroke-width="1"/>
		<text x="400" y="455" text-anchor="middle" font-size="14" fill="#212529">
			Шкала вибору масштабу (зум)
		</text>
	</svg>

	<h6 class="fw-bold mb-2">Панель вибору періоду та метрик</h6>
	<ol class="mb-0">
		<li>
			<strong>Налаштування</strong> <button-icon icon="settings" fill="currentColor"/>: 
			відкриває вікно з параметрами діаграми.
		</li>
		<li>
			<strong>Оновити</strong> <button-icon icon="update" fill="currentColor"/>: 
			заново завантажує метрики ліній для детальнішого перегляду обраного періоду на графіку 
			(корисно після ручного зсуву області видимості на шкалі масштабу).
		</li>
		<li>
			<strong>Назад</strong> <button-icon icon="triangle-left" fill="currentColor"/>: 
			зміщує графік на вибраний період назад.
		</li>
		<li>
			<strong>Період</strong> (випадаючий список): 
			змінює проміжок часу, який показує діаграма; більший період дає меншу деталізацію, 
			але можна змінювати масштаб для детального перегляду.
		</li>
		<li>
			<strong>Вперед</strong> <button-icon icon="triangle-right" fill="currentColor" />: 
			зміщує графік на вибраний період вперед.
		</li>
		<li>
			<strong>Початкова дата</strong> (поле з датою + іконка календаря): 
			показує дату початку періоду; через календар можна змінити цю дату.
		</li>
		<li>
			<strong>Метрики</strong> (випадаючий список): 
			окремий вибір метрик, які відображаються на діаграмі та в таблиці.
		</li>
	</ol>

	<h6 class="fw-bold mt-3 mb-2">Графік ліній метрик</h6>
	Основна область діаграми, де відображається динаміка показників.
	<ul class="mb-3">
		<li>
			<strong>Вісі часу:</strong> розташовані зверху та знизу графіка для зручного орієнтування.
		</li>
		<li>
			<strong>Вісі значень:</strong>
			<ul>
				<li><strong>Зліва:</strong> шкала для метрик з малими значеннями (до 100).</li>
				<li><strong>Справа:</strong> шкала для метрик з великими значеннями (більше 100).</li>
			</ul>
			Ліворуч та праворуч від графіка є кольорові індикатори ліній які прив'язані до шкали з відповідної сторони.
			Щоб показати шкалу конкретної лінії, просто <strong>клікніть на кольоровий кружечок</strong> 
			(маркер) зправа або зліва діаграми — відповідна вісь з'явиться.<br/>
		</li>
		<li>
			<strong>Події та іконки:</strong> під верхньою шкалою часу можуть з'являтися іконки подій 
			(аварії, дії користувача, спрацювання охоронних датчиків та інші).
			<ul>
				<li>Цифра в кутку іконки означає кількість подій, що трапились одночасно або дуже близько в часі.</li>
				<li>Наведіть курсор на іконку, щоб побачити детальний список подій у підказці.</li>
				<li>Кожен тип події має свою унікальну іконку.</li>
				<li>
					<svg xmlns="http://www.w3.org/2000/svg" height="16px" width="16px" viewBox="0 -960 960 960" fill="#5f6368">
						<path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
						<path d="m422-232 207-248H469l29-227-185 267h139l-30 208ZM320-80l40-280H160l360-520h80l-40 320h240L400-80h-80Zm151-390Z"/>
					</svg> 
					- аварії
				</li>
				<li>
					<svg xmlns="http://www.w3.org/2000/svg" height="16px" width="16px" viewBox="0 -960 960 960" fill="#5f6368">
						<path d="M120-120v-80h80v-560q0-33 23.5-56.5T280-840h400q33 0 56.5 23.5T760-760v560h80v80H120Zm560-80v-560H280v560h400ZM560-440q17 0 28.5-11.5T600-480q0-17-11.5-28.5T560-520q-17 0-28.5 11.5T520-480q0 17 11.5 28.5T560-440ZM280-760v560-560Z"/>
					</svg> та 
					<svg xmlns="http://www.w3.org/2000/svg" height="16px" width="16px" viewBox="0 -960 960 960" fill="#5f6368">
						<path d="M120-120v-80h80v-640h400v40h160v600h80v80H680v-600h-80v600H120Zm160-640v560-560Zm160 320q17 0 28.5-11.5T480-480q0-17-11.5-28.5T440-520q-17 0-28.5 11.5T400-480q0 17 11.5 28.5T440-440ZM280-200h240v-560H280v560Z"/>
					</svg>
					- стан дверей шафи СКЗ
				</li>
				<li>
					<svg xmlns="http://www.w3.org/2000/svg" height="16px" width="16px" viewBox="0 -960 960 960" fill="#5f6368">
						<path d="M 480 -480 Z M 370 -80 L 354 -208 C 345.333 -211.333 337.167 -215.333 329.5 -220 C 321.833 -224.667 314.333 -229.667 307 -235 L 188 -185 L 78 -375 L 181 -453 C 180.333 -457.667 180 -462.167 180 -466.5 L 180 -493.5 C 180 -497.833 180.333 -502.333 181 -507 L 78 -585 L 188 -775 L 307 -725 C 314.333 -730.333 322 -735.333 330 -740 C 338 -744.667 346 -748.667 354 -752 L 370 -880 L 590 -880 L 606 -752 C 614.667 -748.667 622.833 -744.667 630.5 -740 C 638.167 -735.333 645.667 -730.333 653 -725 L 772 -775 L 882 -585 L 808 -529 C 793.333 -536.333 778.333 -542.5 763 -547.5 C 747.667 -552.5 731.333 -556 714 -558 L 777 -606 L 738 -674 L 639 -632 C 624.333 -647.333 608.167 -660.167 590.5 -670.5 C 572.833 -680.833 553.667 -688.667 533 -694 L 520 -800 L 441 -800 L 427 -694 C 406.333 -688.667 387.167 -680.833 369.5 -670.5 C 351.833 -660.167 335.667 -647.667 321 -633 L 222 -674 L 183 -606 L 269 -542 C 265.667 -532 263.333 -522 262 -512 C 260.667 -502 260 -491.333 260 -480 C 260 -469.333 260.667 -459 262 -449 C 263.333 -439 265.667 -429 269 -419 L 183 -354 L 222 -286 L 321 -328 C 332.333 -316.667 344.5 -306.5 357.5 -297.5 C 370.5 -288.5 384.667 -281 400 -275 C 400.667 -237 408.5 -201.333 423.5 -168 C 438.5 -134.667 458.667 -105.333 484 -80 L 370 -80 Z M 411 -359 C 415 -372.333 419.833 -385.167 425.5 -397.5 C 431.167 -409.833 437.667 -421.667 445 -433 C 437.667 -438.333 432 -445.167 428 -453.5 C 424 -461.833 422 -470.667 422 -480 C 422 -496.667 427.833 -510.833 439.5 -522.5 C 451.167 -534.167 465.333 -540 482 -540 C 491.333 -540 500.333 -537.833 509 -533.5 C 517.667 -529.167 524.667 -523.333 530 -516 C 541.333 -523.333 553 -529.833 565 -535.5 C 577 -541.167 589.667 -545.667 603 -549 C 591 -570.333 574.333 -587.5 553 -600.5 C 531.667 -613.5 508 -620 482 -620 C 442.667 -620 409.5 -606.333 382.5 -579 C 355.5 -551.667 342 -518.667 342 -480 C 342 -454.667 348.167 -431.167 360.5 -409.5 C 372.833 -387.833 389.667 -371 411 -359 Z"/>
						<path transform="scale(0.7) translate(482 150)" d="m422-232 207-248H469l29-227-185 267h139l-30 208ZM320-80l40-280H160l360-520h80l-40 320h240L400-80h-80Zm151-390Z"/>
					</svg>
					- зміни налаштувань СКЗ
				</li>
				<li>
					<svg xmlns="http://www.w3.org/2000/svg" height="16px" width="16px" viewBox="0 -960 960 960" fill="#5f6368">
						<path d="M640-160v-360H160v360h480Zm80-200v-80h80v-360H320v200h-80v-200q0-33 23.5-56.5T320-880h480q33 0 56.5 23.5T880-800v360q0 33-23.5 56.5T800-360h-80ZM160-80q-33 0-56.5-23.5T80-160v-360q0-33 23.5-56.5T160-600h480q33 0 56.5 23.5T720-520v360q0 33-23.5 56.5T640-80H160Zm400-603ZM400-340Z"/>
					</svg> 
					- кілька типів подій в період часу
				</li>
			</ul>
		</li>
		<li>
			<strong>Відображення коливань:</strong> 
			лінія графіка проходить по середньому значенню (медіані). Якщо показник змінювався, 
			область навколо лінії зафарбовується напівпрозорим кольором — це діапазон від мінімального до максимального значення за потчний період часу.
			При виборі діапазону коротше 6-ти годин, лінії будуються по точним значенням з точним часом зчитування метрик.
		</li>
		<li>
			<strong>Ручне збільшення:</strong> при виборі діапазону на шкалі вибору масштабу, на графіку будуть відображені попередньо завантажені дані. 
			Щоб уточнити дані натисніть кнопку "Оновити".
		</li>
		<li>
			<strong>Швидке збільшення (зум):</strong>
			Подвійний клік у будь-якому місці графіка наближає зображення. 
			Кожен подвійний клік збільшує масштаб послідовно: у 2, 4, 10, 20, 100 і навіть 1000 разів. 
			Наступний клік після максимального збільшення повертає графік до початкового вигляду (1:1).
		</li>
	</ul>

	<h6 class="fw-bold mb-2">Діаграма метрик якості зв'язку</h6>
	<p class="mb-2">
		Ця частина показує стан обладнання та якість з'єднання. 
		Діаграма має два режими відображення, які перемикаються 
		<strong>кнопкою праворуч</strong> від неї (<button-icon icon="analytic-chart-type" edge-size="18" fill="currentColor" />).
	</p>

	<p class="mb-0 fw-bold">1. Секційний вигляд (за замовчуванням)</p>
	<p class="mb-2">
		Відображає стан параметрів у часі у вигляді кольорових смуг. Зелений колір означає "Норма", червоний — "Проблема".
	</p>
	<ul class="mb-2">
		<li>
			<strong>Температура шафи: </strong> 
			<span class="fw-bold" :style="{'color': GREEN}">зелений</span>, 
			якщо температура в межах від -40°C до +50°C. В іншому випадку — 
			<span class="fw-bold" :style="{'color': RED}">червоний</span>.
		</li>
		<li>
			<strong>Напруга живлення 230В: </strong> 
			<span class="fw-bold" :style="{'color': GREEN}">зелений</span>, 
			якщо напруга знаходиться в дозволеному діапазоні 
			(між <em>Uмін</em> та <em>Uмакс</em>, заданими в налаштуваннях 
			живлення сервісного модуля). Якщо виходить за межі — 
			<span class="fw-bold" :style="{'color': RED}">червоний</span>.
		</li>
		<li>
			<strong>Зв'язок (Силовий модуль, Сервісний модуль, Модем): </strong> 
			три окремі рядки. <span class="fw-bold" :style="{'color': GREEN}">Зелений</span> — 
			зв'язок є, <span class="fw-bold" :style="{'color': RED}">червоний</span> — 
			зв'язок відсутній.
		</li>
	</ul>
	<p class="mb-0 fw-bold">2. Стовпчаста діаграма зв'язку модема</p>
	<p class="mb-2 paragraph-indent">
		Цей режим показує статистику зв'язку модема. На діаграмі відображаються 
		стовпчики, висота яких відповідає кількості подій. 
		Також, крапкою поверх діаграми, відображається налаштування періоду опитування станції.
		Чим вище крапка, тим більше період опитування.
	</p>
	<ul>
		<li>Кількість успішних сеансів зв'язку.</li>
		<li>Кількість різнотипових помилок (обриви, таймаути тощо).</li>
	</ul>

	<h6 class="fw-bold mb-2">Шкала вибору масштабу</h6>
	<p class="mb-2 paragraph-indent">
		Ця панель (синя смуга в самому низу) показує весь завантажений період часу. 
		Темніша, виділена область на ній позначає саме той відрізок часу, який зараз 
		розгорнуто на діаграмі (по замовчуванню це весь завантажений період).
	</p>
	<ul class="mb-2">
		<li>
			<strong>Вибір інтервалу (масштабування):</strong> натисніть ліву кнопку миші на вільному місці шкали та потягніть, 
			щоб виділити бажаний інтервал. Після того як ви відпустите кнопку, діаграма автоматично масштабується 
			на вибрану область.
		</li>
		<li>
			<strong>Переміщення:</strong> ви можете схопити виділену область мишкою і рухати її вліво або вправо, 
			щоб "прокручувати" графік у часі, не змінюючи масштаб.
		</li>
		<li>
			<strong>Зміна меж:</strong> потягніть за лівий або правий край виділеної області, 
			щоб розширити (бачити більше часу) або звузити (бачити більше деталей) поточний перегляд.
		</li>
	</ul>
	<h6 class="fw-bold mb-2">Таблиця метрик</h6>
	<p class="mb-2 paragraph-indent">
		Таблиця метрик вмикається кнопкою 
		<svg xmlns="http://www.w3.org/2000/svg" height="16px" width="16px" viewBox="0 0 16 16" fill="#5f6368">
			<path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm15 2h-4v3h4zm0 4h-4v3h4zm0 4h-4v3h3a1 1 0 0 0 1-1zm-5 3v-3H6v3zm-5 0v-3H1v2a1 1 0 0 0 1 1zm-4-4h4V8H1zm0-4h4V4H1zm5-3v3h4V4zm4 4H6v3h4z"/>
		</svg>.
		В таблиці показані значення обраних метрик в діапазоні 2-х годин. Центр діапазону обирається кліком по діаграмі.
		Обраний діапазон часу додатково позначається виділенням зони на графіку. 
		Обраний на діаграмі центр діапазону відповідає центральному стовпчику таблиці.
	</p>
	<p class="mb-2 paragraph-indent">
		В таблиці показуються точні метрики з точним часом. Після першої активації таблиці треба обрати діапазон 
		кліком на графіку і почнеться завантаження точних метрик. По замовчуванню всі рядки синхронізовані з часом метрик 
		першого рядка. Тобто інші рядки заповнюються значеннями, що знаходяться найближче по часу до значень першого рядка. 
		Рядок, з яким синхронізуються всі інші можна обрати простим наведенням на нього вказівника миші. 
		Обраний рядок буде виділено сірим фоном.
	</p>
	<p class="mb-2 paragraph-indent">
		При зміні періоду графіка (крім зуму), обраний діапазон залишається <strong>поза зоною видимості</strong> графіка. 
		В таблиці будуть відображатись ті данні що були завантажені раніше. Для переміщення фокусу таблиці треба обрати 
		діапазон кліком на графіку.
	</p>
</div>
</template>


<script>
import ButtonIcon from '@/components/Icons/ButtonIcon.vue'

const GREEN = '#73bf69'
const RED = '#f2495c'

export default {
	components: {
		ButtonIcon,
	},

	setup() {
		return {
			GREEN,
			RED,
		}
	},

	data() {
		return {}
	},
}
</script>